/** @jsx jsx */
// External libraries
import { jsx } from '@emotion/core';
import { useStoreActions, useStoreState } from 'easy-peasy';

// Internal modules
import { Form } from '../Form';
import { mainStyles } from './styles';
import {
  HaveAnAccountLogIn,
  LazyConsumerAddBankForm,
  LazyVenmoMessage,
} from './Components';
import { PageLevelError } from '../PageLevelError';
import { features, getParams, useMountLogging } from '@/lib';

const Main = () => {
  useMountLogging('Main');
  const setIsPayWithVenmo = useStoreActions(({ ui }) => ui.setIsPayWithVenmo);
  setIsPayWithVenmo(getParams().fundingSource === 'venmo');

  const isPayWithVenmo = useStoreState(({ ui }) => ui.isPayWithVenmo);
  const pageLevelError = useStoreState(({ ui }) => ui.pageLevelError);
  const fiType = useStoreState(({ ui }) => ui.fiType);
  const hasConsumerAddBank = features.isActive('hasConsumerAddBank');

  return (
    <main css={mainStyles}>
      {Boolean(pageLevelError.length) && <PageLevelError />}

      {isPayWithVenmo && <LazyVenmoMessage />}

      {hasConsumerAddBank && fiType === 'bank' ? (
        <LazyConsumerAddBankForm />
      ) : (
        <Form />
      )}

      <HaveAnAccountLogIn />
    </main>
  );
};

export { Main };
